import React from "react";
import { Chip } from "@mui/material";

const StatusChip = ({ requestedAt }) => {
  const calculateDaysOpen = (dateStr) => {
    if (!dateStr) return "N/A";
    const start = new Date(dateStr);
    const now = new Date();
    const diffTime = Math.abs(now - start);
    return Math.ceil(diffTime / (1000 * 60 * 60 * 24));
  };

  return (
    <Chip
      label={`Open for ${calculateDaysOpen(requestedAt)} days`}
      sx={{
        backgroundColor: "rgba(132, 155, 6, 0.2)",
        color: "#444",
        fontWeight: "bold",
        fontSize: "14px",
        padding: "6px 12px",
        borderRadius: "20px",
        backdropFilter: "blur(8px)",
        border: "1px solid rgba(255, 255, 255, 0.4)",
        boxShadow: "0px 2px 10px rgba(0, 0, 0, 0.1)",
        transition: "0.3s ease-in-out",
        "&:hover": {
          backgroundColor: "rgba(255, 255, 255, 0.3)",
        },
      }}
    />
  );
};

export default StatusChip;
